/**
 * Copyright 2022 MobiledgeX, Inc
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { createTheme } from '@mui/material/styles';

export const THEME_TYPE = {
    LIGHT: 'light',
    DARK: 'dark'
}


export const getDarkTheme = () => {
    return createTheme({
        palette: {
            mode: 'dark',
            primary: {
                main: '#e20074',
            },
            background: {
                default: '#1c1c1e',
            },
        },
        typography: {
            fontFamily: "TeleNeoWeb",
        },
        components: {
            MuiPaper: {
                styleOverrides: {
                    root: {
                        backgroundColor: '#1c1c1e',
                        backgroundImage: "none",
                        /*marginBottom: -8,*/
                    },
                },
            },
            MuiCard: {
                styleOverrides: {
                    root: {
                        backgroundColor: '#1c1c1e',
                        backgroundImage: "none",
                    },
                },
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        color: '#ffffffff',
                        backgroundColor: '#e20074',
                        backgroundImage: "none",
                    },
                },
            },
/*            MuiDialog: {
                styleOverrides: {
                    root: {
                        background: '#1c1c1e',
                    },
                },
            },
            */
        }
    });
}

export const getLightTheme = () => {
    return createTheme({
        palette: {
            mode: 'light',
            primary: {
                main: '#2f46ff',
            },
            background: {
                default: '#fff',
            },
        },
        components: {
            MuiIconButton: {
                root: {
                    color: 'red !important'
                },
            },
            MuiToolbar: {
                regular: {
                    backgroundColor: "#2f46ff",
                    color: "#fff",
                    /*height: "22px",
                    minHeight: "22px",*/
                    '@media (min-width: 600px)': {
                        minHeight: "48px"
                    }
                },
            },
            MuiList: {
                root: {
                    backgroundColor: "#fff",
                    background: "#fff !important",
                    color: '#1c1b19 !important'
                },
            },
            MuiSvgIcon: {
                root: {
                    color: '#1026bb',
                }
            },
            MuiCard: {
                root: {
                    //marginTop: '-18px',
                    background: '#2f46ff !important',
                    backgroundColor: '#2f46ff !important'
                }
            }

        }
    });
}
